import React, { useState, useEffect, useRef, useContext } from "react";
import { IoPersonSharp } from "react-icons/io5";
import { FaSearch, FaBars, FaTimes } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import solarsystem from "../assets/rootimg/kundli2.jpg";
import axios from 'axios';
import { AuthContext } from "./AuthContext";
import logoimg from "../assets/rootimg/astrotellerlogo.png";


const CommonNavbar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [showSearch, setShowSearch] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const sidebarRef = useRef(null);
  const searchInputRef = useRef(null);
  const profileDropdownRef = useRef(null);
  const navigate = useNavigate();
  const [openDropdowns, setOpenDropdowns] = useState({});

  const { isLoading, setIsLogged } = useContext(AuthContext);

  const handleLogout = () => {
    setIsLogged(false);
    localStorage.removeItem("authToken");
    setProfileDropdownOpen(false);
    navigate("/login");
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsVisible(currentScrollY <= lastScrollY);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  useEffect(() => {
    if (showSearch && searchInputRef.current) searchInputRef.current.focus();
  }, [showSearch]);


  // sidebar ref
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [sidebarRef]);

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    // Flatten all routes from categories into a single array
    const allRoutes = Object.values(routeCategories).flat();

    // Filter routes based on the search query
    const filteredSuggestions = allRoutes.filter(route =>
      route.name.toLowerCase().includes(query.toLowerCase())
    );

    setSuggestions(filteredSuggestions);
    setHighlightedIndex(-1);
  };

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      setHighlightedIndex(prev => (prev + 1) % suggestions.length);
    } else if (e.key === "ArrowUp") {
      setHighlightedIndex(prev => (prev - 1 + suggestions.length) % suggestions.length);
    } else if (e.key === "Enter" && highlightedIndex >= 0) {
      navigate(suggestions[highlightedIndex].path);
      setShowSearch(false);
    }
  };

  // Organize routes into categories
  const routeCategories = {
    "Horoscope": [
      { path: "/horoscope", name: "Horoscope" },
      { path: "/weekly-horoscope", name: "Weekly Horoscope" },
      { path: "/Daily-horoscope", name: "Daily Horoscope" },
      { path: "/yearly-horoscope", name: "Yearly Horoscope" },
    ],
    "Chart's Predictions": [
      { path: "/new-kundli", name: "Kundli" },
      { path: "/kundlimatching", name: "Kundli Matching" },
      { path: "/natalchart", name: "Natal Chart" },
    ],
    "Compatibility": [
      { path: "/compatibility", name: "Compatibility" },
      { path: "/work/compatibility", name: "Work Compatibility" },
      { path: "/love/compatibility", name: "Love Compatibility" },
      { path: "/chinese/compatibility", name: "Chinese Compatibility" },
    ],
    "Tarot Reading": [
      { path: "/tarot", name: "Tarot" },
      { path: "/daily/tarot", name: "Daily Tarot" },
      { path: "/career/tarot", name: "Career Tarot" },
      { path: "/yes&no/tarot", name: "Yes/No Tarot" },
      { path: "/lovepotential/tarot", name: "Love Potential Tarot" },
      { path: "/flirt/tarot", name: "Flirt Tarot" },
      { path: "/love/tarot", name: "Love Tarot" },
    ],
    "Panchang": [
      { path: "/daily/panchang", name: "Panchang" },
      { path: "/hora/panchang", name: "Hora Panchang" },
      { path: "/chaughadiya/panchang", name: "Chaughadiya Panchang" },
    ],
    "Numerology": [
      { path: "/numero", name: "Numero" }
    ],
    "Other": [
      { path: "/blog", name: "Blog" },
    ]
  };

  const toggleDropdown = (category) => {
    setOpenDropdowns(prev => {
      // Create a new object with all dropdowns closed
      const newState = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});

      // Toggle only the clicked category
      return {
        ...newState,
        [category]: !prev[category]
      };
    });
  };

  if (isLoading) return null; // Loader or spinner here

  return (
    <>
      <div
        className={`fixed top-0 w-full bg-gray-100 shadow-lg transition-transform duration-300 z-50 ${isVisible ? "translate-y-0" : "-translate-y-full"}`}
      >
        <h1 className="text-center text-xs bg-secondary text-gray-200 py-1">
          Welcome to the AstroTellers
        </h1>

        <header className="flex items-center justify-between px-2 md:px-2 lg:px-3 py-4">
          {/* Logo and Title */}
          <div className="flex ml-2 lg:w-[13%] md:w-[20%] sm:w-[20%] w-[43%]">
            <img
              src={logoimg}
              alt="astrologo.png"
              className="w-full h-auto rounded-full mr-1 object-cover"
              onClick={() => navigate("/")}
            />
          </div>

          {/* Search bar ref div */}
          <div
            className={`absolute top-6 left-0 right-0 transition-all duration-300 bg-gray-100 ${showSearch ? "h-auto px-4 py-4 flex items-center w-full" : "h-0 overflow-hidden"}`}
          >
            <input
              type="text"
              ref={searchInputRef}
              value={searchQuery}
              onChange={handleSearchChange}
              onKeyDown={handleKeyDown}
              placeholder="Search..."
              className="w-full px-4 py-2 border border-secondary bg-white rounded-md z-10 focus:outline-none"
            />
            <button
              className="ml-2 text-gray-600"
              onClick={() => setShowSearch(false)}
            >
              <FaTimes size={18} />
            </button>
            {/* search bar suggestion div */}
            {searchQuery && suggestions.length > 0 && (
              <div
                className="absolute top-16 left-0 right-0 bg-white border border-gray-300 z-20 shadow-lg rounded-md"
                onKeyDown={handleKeyDown}
                tabIndex={0}
              >
                {suggestions.map((suggestion, index) => (
                  <Link
                    key={index}
                    to={suggestion.path}
                    className={`block px-4 py-2 hover:bg-gray-400 hover:text-white transition duration-200 ${highlightedIndex === index ? "bg-gray-200 text-gray-800" : "text-gray-800"}`}
                    onClick={() => setShowSearch(false)}
                  >
                    {suggestion.name}
                  </Link>
                ))}
              </div>
            )}
          </div>
          {/* large device links  */}
          <nav className="hidden lg:flex md:gap-1 lg:gap-4">
            {/* Horoscope Dropdown */}
            <div className="relative group">
              <Link to="/horoscope" className="hover:text-secondary link-hover text-base flex items-center">
                HOROSCOPE
              </Link>
              <div className="absolute top-full mt-2 left-0 w-48 bg-white shadow-lg rounded-md hidden group-hover:block">
                <Link to="/daily-horoscope" className="block px-4 py-2 hover:bg-gray-100">Daily</Link>
                <Link to="/weekly-horoscope" className="block px-4 py-2 hover:bg-gray-100">Weekly</Link>
                <Link to="/yearly-horoscope" className="block px-4 py-2 hover:bg-gray-100">Yearly</Link>
              </div>
            </div>

            {/* Panchang Dropdown */}
            <div className="relative group">
              <Link to="/daily/panchang" className="hover:text-secondary link-hover text-base flex items-center">
                PANCHANG
              </Link>
              <div className="absolute top-full mt-2 left-0 w-48 bg-white shadow-lg rounded-md hidden group-hover:block">
                <Link to="/daily/panchang" className="block px-4 py-2 hover:bg-gray-100">Daily Panchang</Link>
                <Link to="/hora/panchang" className="block px-4 py-2 hover:bg-gray-100">Hora Panchang</Link>
                <Link to="/chaughadiya/panchang" className="block px-4 py-2 hover:bg-gray-100">Chaughadiya Panchang</Link>
              </div>
            </div>

            {/* Compatibility Dropdown */}
            <div className="relative group">
              <Link to="/compatibility" className="hover:text-secondary link-hover text-base flex items-center">
                COMPATIBILITY
              </Link>
              <div className="absolute top-full mt-2 left-0 w-48 bg-white shadow-lg rounded-md hidden group-hover:block">
                <Link to="/work/compatibility" className="block px-4 py-2 hover:bg-gray-100">Work Compatibility</Link>
                <Link to="/love/compatibility" className="block px-4 py-2 hover:bg-gray-100">Love Compatibility</Link>
                <Link to="/chinese/compatibility" className="block px-4 py-2 hover:bg-gray-100">Chinese Compatibility</Link>
              </div>
            </div>

            {/* Kundli Dropdown */}
            <div className="relative group">
              <Link to="/new-kundli" className="hover:text-secondary link-hover text-base flex items-center">
                KUNDLI
              </Link>
              <div className="absolute top-full mt-2 left-0 w-48 bg-white shadow-lg rounded-md hidden group-hover:block">
                <Link to="/new-kundli" className="block px-4 py-2 hover:bg-gray-100">Kundli</Link>
                <Link to="/kundlimatching" className="block px-4 py-2 hover:bg-gray-100">Match Kundli</Link>
                <Link to="/natalchart" className="block px-4 py-2 hover:bg-gray-100">Natal Chart</Link>
              </div>
            </div>

            <Link to="/numero" className="hover:text-secondary link-hover text-base">
              NUMERO
            </Link>

            {/* Tarot Dropdown */}
            <div className="relative group">
              <Link to="/tarot" className="hover:text-secondary link-hover text-base flex items-center">
                TAROT
              </Link>
              <div className="absolute top-full mt-2 left-0 w-48 bg-white shadow-lg rounded-md hidden group-hover:block">
                <Link to="/tarot" className="block px-4 py-2 hover:bg-gray-100">Tarot</Link>
                <Link to="/daily/tarot" className="block px-4 py-2 hover:bg-gray-100">Daily Tarot</Link>
                <Link to="/love/tarot" className="block px-4 py-2 hover:bg-gray-100">Love Tarot</Link>
                <Link to="/flirt/tarot" className="block px-4 py-2 hover:bg-gray-100">Flirt Tarot</Link>
                <Link to="/lovepotential/tarot" className="block px-4 py-2 hover:bg-gray-100">Love Potential Tarot</Link>
                <Link to="/yes&no/tarot" className="block px-4 py-2 hover:bg-gray-100">Yes/No Tarot</Link>
                <Link to="/career/tarot" className="block px-4 py-2 hover:bg-gray-100">Career Tarot</Link>
              </div>
            </div>

            <Link to="/blog" className="hover:text-secondary link-hover text-base">
              BLOG
            </Link>
          </nav>

          {/* Search bar  */}
          <div className="flex items-center gap-3">
            <button
              onClick={() => setShowSearch(!showSearch)}
              className="bg-secondary text-white p-2 rounded-md hover:bg-gray-900 transition"
            >
              <FaSearch />
            </button>

            <button
              className="lg:hidden text-gray-900"
              onClick={() => setSidebarOpen(!sidebarOpen)} // Toggle sidebar when clicked
            >
              {sidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </header>

        {/* Mobile and Medium Devices Sidebar */}
        <div
          ref={sidebarRef}
          className={`fixed top-0 left-0 min-h-screen w-3/5 max-w-xs bg-secondary transform ${sidebarOpen ? "translate-x-0" : "-translate-x-full"
            } transition-transform duration-300 z-50 shadow-lg lg:hidden overflow-y-auto`}
        >
          <div className="p-4">
            <button
              onClick={() => setSidebarOpen(false)}
              className="absolute top-2 right-2 text-gray-700"
            >
              <FaTimes size={24} />
            </button>
            <nav className="flex flex-col text-center mb-6 gap-2 mt-10">
              <div className="flex items-center justify-center text-center bg-white rounded-md px-3 py-2 mb-2">
                <img
                  src={logoimg}
                  alt="astrologo.png"
                  className="w-full h-auto rounded-full mr-1 object-cover"
                  onClick={() => navigate("/")}
                />

              </div>

              {Object.entries(routeCategories).map(([category, routes]) => (
                <div key={category} className="w-full space-y-3">
                  <button
                    onClick={() => toggleDropdown(category)}
                    className="w-full flex items-center text-center justify-center bg-gray-50 text-gray-950 rounded-md p-2 transition-transform duration-200"
                  >
                    <span className="font-semibold">{category}</span>
                  </button>

                  {openDropdowns[category] && (
                    <div
                      className="mt-1 pl-2 pr-2 space-y-2 overflow-hidden transition-all duration-700 ease-in-out"
                      style={{
                        maxHeight: openDropdowns[category] ? '500px' : '0', // Adjust maxHeight as needed
                        opacity: openDropdowns[category] ? 1 : 0,
                        paddingTop: openDropdowns[category] ? '0.5rem' : '0',
                        paddingBottom: openDropdowns[category] ? '0.5rem' : '0',
                      }}
                    >
                      {routes.map((route, index) => (
                        <Link
                          key={index}
                          to={route.path}
                          className="block w-full text-left bg-gray-100 rounded-md p-2 text-gray-950"
                          onClick={() => setSidebarOpen(false)}
                        >
                          {route.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </nav>
          </div>
        </div>
      </div>
      <div className="h-20 md:h-24"></div>
    </>
  )
}

export default CommonNavbar